import { DesktopRegular, WeatherMoonRegular, WeatherSunnyRegular } from '@fluentui/react-icons';
import type { JSX } from 'react';

import type { ThemeMode } from './themeStorage';

/**
 * Icons and labels for the light/dark/system choice, shared by the top bar's
 * `ThemeToggle` menu and the settings page's radio group so the two can never
 * drift into calling the same option different things.
 */

export const MODE_ICONS: Record<ThemeMode, JSX.Element> = {
  light: <WeatherSunnyRegular />,
  dark: <WeatherMoonRegular />,
  system: <DesktopRegular />,
};

export const MODE_LABELS: Record<ThemeMode, string> = {
  light: 'Light',
  dark: 'Dark',
  system: 'Match system',
};

export const MODE_ORDER: readonly ThemeMode[] = ['light', 'dark', 'system'];
